/*
 * HomePage
 */

import React from 'react';

// Material Resources

// Others
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components & Others
import NotFound from '../../NotFoundPage';
import InstrumentList from '../../../components/Models/Instrument/InstrumentList';
import InstrumentEdit from '../../../components/Models/Instrument/InstrumentCreateEdit/edit';
import InstrumentForm from '../../../components/Models/Instrument/InstrumentForm';

function InstrumentPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={InstrumentList} />
      <Route path={`${path}/crear`} component={InstrumentForm} />
      <Route path={`${path}/:id`} component={InstrumentEdit} />
      <Route path="" component={NotFound} />
    </Switch>
  );
}

export default InstrumentPage;
